module.exports = __webpack_public_path__ + "img/multiSlectedEle.d9d86b72.svg";